"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AccessControlPolicy_1 = require("./_AccessControlPolicy");
exports.PutBucketAclInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        ACL: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-acl"
        },
        AccessControlPolicy: {
            shape: _AccessControlPolicy_1._AccessControlPolicy,
            locationName: "AccessControlPolicy",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        },
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        GrantFullControl: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-grant-full-control"
        },
        GrantRead: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-grant-read"
        },
        GrantReadACP: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-grant-read-acp"
        },
        GrantWrite: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-grant-write"
        },
        GrantWriteACP: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-grant-write-acp"
        }
    },
    payload: "AccessControlPolicy"
};
//# sourceMappingURL=PutBucketAclInput.js.map